import {I18NMultiple} from '../globals/config';
import {sanitize} from 'dompurify';

/**
 * Format counted message.
 *
 * @param  message
 * @param  count
 */
export function formatCounted( message: I18NMultiple, count: number ): string {
	return sanitize( message[ 1 === count ? 'single' : 'multiple' ]
		.replace( '%d', `<strong>${count.toString()}</strong>` ) );
}
